import { jsx as _, jsxs as P } from "react/jsx-runtime";
import { forwardRef as S, useState as E, useRef as z, useImperativeHandle as W, useEffect as N, useLayoutEffect as Y } from "react";
import { createPortal as A } from "react-dom";
import { useBreakpoint as L } from "./components/Breakpoint/BreakpointProvider.js";
import { d as C } from "./DropDownMLP1.module-cbdfc4d8.mjs";
import { d as V } from "./DropDownMLP2.module-048ce0a5.mjs";
import { isElementEmpty as x, getContainerPortalId as I } from "./utils/index.js";
import { DEFAULT_PORTAL_CONTAINER_ID as M } from "./types/enums.js";
import D from "./hooks/useClickOutsideDetector.js";
import "./components/Modal/types/enums.js";
import './assets/RawModal.css';const H = "#ffffff", T = "#396e75", j = "#e5fdff", q = "#546223", F = "#f0fae5", U = "#a65523", J = "#fff1e8", K = "#7f3e3e", Q = "#ffe2e2", X = "#62625a", Z = "#f8f8e7", ee = "#38539a", te = "#707070", ae = "#c8f8d1", oe = "#87c9c8", ne = "#5291b1", re = "rgba(82, 145, 177, 0.1019607843)", ie = "#445685", de = "#181d61", le = "rgba(24, 29, 97, 0.1019607843)", ce = "#5969d6", _e = "#ea999d", se = "#b6577e", ge = "rgba(182, 87, 126, 0.1019607843)", ue = "#7e3e80", me = "#1e247f", pe = "rgba(30, 36, 127, 0.1019607843)", fe = "#da7600", he = "#107f47", ke = "#d91734", ze = "_html_ggeue_46", b = {
  amwayWhite: H,
  darkBlue: T,
  lightBlue: j,
  darkGreen: q,
  lightGreen: F,
  darkOrange: U,
  lightOrange: J,
  darkRed: K,
  lightRed: Q,
  darkYellow: X,
  lightYellow: Z,
  darkPurple: ee,
  darkGrayOnWhite: te,
  dataVizColor1: ae,
  dataVizColor2: oe,
  dataVizColor3: ne,
  dataVizColor3Background: re,
  dataVizColor4: ie,
  dataVizColor5: de,
  dataVizColor5Background: le,
  dataVizColor6: ce,
  dataVizColor7: _e,
  dataVizColor8: se,
  dataVizColor8Background: ge,
  dataVizColor9: ue,
  dataVizColor10: me,
  dataVizColor10Background: pe,
  dataVizAlertOrange: fe,
  dataVizSuccessGreen: he,
  dataVizWarningRed: ke,
  "no-visible": "_no-visible_ggeue_42",
  html: ze,
  "date-picker-container": "_date-picker-container_ggeue_80",
  "date-picker-container-within-modal": "_date-picker-container-within-modal_ggeue_81",
  "mlp-version-2": "_mlp-version-2_ggeue_82",
  "input-label": "_input-label_ggeue_86",
  "date-picker-tool-tip": "_date-picker-tool-tip_ggeue_102",
  "required-indicator": "_required-indicator_ggeue_110",
  "icon-close": "_icon-close_ggeue_115",
  "menu-container": "_menu-container_ggeue_123",
  "default-width": "_default-width_ggeue_139",
  "full-width": "_full-width_ggeue_145",
  "within-drawer": "_within-drawer_ggeue_145",
  "calendar-header": "_calendar-header_ggeue_158",
  "calendar-header-title": "_calendar-header-title_ggeue_169",
  "description-container": "_description-container_ggeue_188",
  "calendar-body": "_calendar-body_ggeue_199",
  "datepicker-modal-header-section": "_datepicker-modal-header-section_ggeue_204",
  "modal-icon-section": "_modal-icon-section_ggeue_215",
  "modal-headline": "_modal-headline_ggeue_220",
  "input-container": "_input-container_ggeue_225",
  "datepicker-default": "_datepicker-default_ggeue_241",
  "input-container-active": "_input-container-active_ggeue_247",
  "calendar-modal-container": "_calendar-modal-container_ggeue_260",
  "datepicker-valid": "_datepicker-valid_ggeue_265",
  "datepicker-invalid": "_datepicker-invalid_ggeue_271",
  "datepicker-input-disabled": "_datepicker-input-disabled_ggeue_277",
  "placeholder-container": "_placeholder-container_ggeue_286",
  "calendar-state-open": "_calendar-state-open_ggeue_306",
  "action-button-container": "_action-button-container_ggeue_316",
  "action-button": "_action-button_ggeue_316",
  "primary-action-button": "_primary-action-button_ggeue_336",
  "modal-action-button-container": "_modal-action-button-container_ggeue_341",
  "datePicker-modal-description-container": "_datePicker-modal-description-container_ggeue_347",
  "calendar-icon": "_calendar-icon_ggeue_364",
  "calendar-wrapper": "_calendar-wrapper_ggeue_369",
  "calendar-footer": "_calendar-footer_ggeue_376",
  "calendar-heading": "_calendar-heading_ggeue_384",
  "skeleton-loading": "_skeleton-loading_ggeue_1"
}, Ce = "#ffffff", Ve = "#396e75", be = "#e5fdff", we = "#546223", ve = "#f0fae5", $e = "#a65523", ye = "#fff1e8", Be = "#7f3e3e", Re = "#ffe2e2", Oe = "#62625a", Ge = "#f8f8e7", Pe = "#38539a", Se = "#707070", Ee = "#c8f8d1", We = "#87c9c8", Ne = "#5291b1", Ye = "rgba(82, 145, 177, 0.1019607843)", Ae = "#445685", Le = "#181d61", xe = "rgba(24, 29, 97, 0.1019607843)", Ie = "#5969d6", Me = "#ea999d", De = "#b6577e", He = "rgba(182, 87, 126, 0.1019607843)", Te = "#7e3e80", je = "#1e247f", qe = "rgba(30, 36, 127, 0.1019607843)", Fe = "#da7600", Ue = "#107f47", Je = "#d91734", Ke = "_html_1v5p7_46", r = {
  amwayWhite: Ce,
  darkBlue: Ve,
  lightBlue: be,
  darkGreen: we,
  lightGreen: ve,
  darkOrange: $e,
  lightOrange: ye,
  darkRed: Be,
  lightRed: Re,
  darkYellow: Oe,
  lightYellow: Ge,
  darkPurple: Pe,
  darkGrayOnWhite: Se,
  dataVizColor1: Ee,
  dataVizColor2: We,
  dataVizColor3: Ne,
  dataVizColor3Background: Ye,
  dataVizColor4: Ae,
  dataVizColor5: Le,
  dataVizColor5Background: xe,
  dataVizColor6: Ie,
  dataVizColor7: Me,
  dataVizColor8: De,
  dataVizColor8Background: He,
  dataVizColor9: Te,
  dataVizColor10: je,
  dataVizColor10Background: qe,
  dataVizAlertOrange: Fe,
  dataVizSuccessGreen: Ue,
  dataVizWarningRed: Je,
  "no-visible": "_no-visible_1v5p7_42",
  html: Ke,
  "modal-container": "_modal-container_1v5p7_80",
  "modal-dialog": "_modal-dialog_1v5p7_84",
  "close-icon": "_close-icon_1v5p7_122",
  "modal-headline": "_modal-headline_1v5p7_127",
  "modal-headline-left": "_modal-headline-left_1v5p7_136",
  "modal-headline-center": "_modal-headline-center_1v5p7_139",
  "modal-content-center": "_modal-content-center_1v5p7_142",
  "modal-content-left": "_modal-content-left_1v5p7_164",
  "modal-header-section": "_modal-header-section_1v5p7_186",
  "modal-icon-section": "_modal-icon-section_1v5p7_193",
  "modal-footer-section": "_modal-footer-section_1v5p7_208",
  "modal-bottom-container": "_modal-bottom-container_1v5p7_218",
  "modal-bottom-without-secondary": "_modal-bottom-without-secondary_1v5p7_227",
  "modal-bottom-no-footer": "_modal-bottom-no-footer_1v5p7_236",
  "bottom-container": "_bottom-container_1v5p7_239",
  "modal-button-container": "_modal-button-container_1v5p7_249",
  "align-horizontal-button": "_align-horizontal-button_1v5p7_256",
  "align-vertical-button": "_align-vertical-button_1v5p7_256",
  "text-link": "_text-link_1v5p7_264",
  "modal-content": "_modal-content_1v5p7_142",
  "align-default-button": "_align-default-button_1v5p7_308",
  "primary-button-with-textlink": "_primary-button-with-textlink_1v5p7_315",
  "skeleton-loading": "_skeleton-loading_1v5p7_1"
};
function p(a, i, d, s) {
  const l = Array.from(
    a.current.getElementsByClassName(i)
  ), e = Array.from(
    a.current.getElementsByClassName(d)
  );
  e != null && e.length && l.forEach((c, t) => {
    if (e != null && e[t]) {
      const o = c.getBoundingClientRect();
      s ? (e[t].style.left = `${o.left - a.current.getBoundingClientRect().left}px`, e[t].style.margin = "0") : e[t].style.left = "unset", e[t].style.top = `${o.top - a.current.getBoundingClientRect().top + o.height + 8}px`, e[t].style.right = "unset", e[t].style.position = "fixed", e[t].style.width = `${o.width}px`;
    }
  });
}
const Qe = S(
  ({
    header: a,
    children: i,
    containerWidth: d,
    textAlign: s,
    closeOnBackdropClick: l = !0,
    onClose: e,
    id: c,
    footer: t,
    className: o,
    footerClassname: w,
    useReactPortal: v = !1,
    portalContainerId: $ = M
  }, y) => {
    const [B, R] = E(!1), n = z(), f = z(), O = L();
    W(y, () => n.current);
    const G = (() => l ? e : void 0)();
    D(n, G, [l], f);
    function g() {
      const m = document.getElementById(`nextgen-modal-content-${c}`);
      m && R(m.scrollHeight > Math.ceil(m.getBoundingClientRect().height));
    }
    N(() => (g(), window.addEventListener("resize", g), () => window.removeEventListener("resize", g)), [i]), Y(() => {
      p(
        n,
        V["mlp-2-dropdown-modal"],
        V["dropdown-drawer"],
        !1
      ), p(
        n,
        C["dropdown-container-modal"],
        C["base-dropdown-result"],
        !1
      ), p(
        n,
        b["date-picker-container-within-modal"],
        b["menu-container"],
        !0
      );
    }, [O]);
    let u = r["modal-bottom-without-secondary"];
    B && (u += ` ${r["bottom-container"]}`), (!t || x(t)) && (u += ` ${r["modal-bottom-no-footer"]}`);
    const h = /* @__PURE__ */ _("div", { ref: f, "data-testid": "modal-container-data-testid", "data-pod-name": "fwk", children: /* @__PURE__ */ _("section", { className: r["modal-dialog"], children: /* @__PURE__ */ P(
      "section",
      {
        className: `${r["modal-container"]} ${o}`,
        style: d ? { width: d } : {},
        ref: n,
        children: [
          a,
          /* @__PURE__ */ _(
            "section",
            {
              id: `nextgen-modal-content-${c}`,
              className: r[`modal-content-${s}`],
              "data-testid": "content-test-id",
              "data-pod-name": "fwk",
              children: i
            }
          ),
          /* @__PURE__ */ _("section", { className: `${u} ${w}`, children: t })
        ]
      }
    ) }) }), k = I($);
    return v && k ? A(h, k) : h;
  }
);
Qe.displayName = "RawModal";
export {
  Qe as R,
  b as d,
  r as s
};
//# sourceMappingURL=RawModal-fa1b0565.mjs.map
